import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import API from '@/lib/api'

type SentDoc = { uuid?: string; status?: string; sentAt?: string | null }

/**
 * Ruční označení faktury nebo výzvy k platbě jako odeslané (vlastní e-mail, SMS, osobně) a jeho zrušení.
 * Náklady a zrušené doklady označit nejde.
 */
export const useDocumentSent = (doc: SentDoc | null | undefined, kind: 'invoice' | 'order' | 'expense', onDone: () => void) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'documentDetail.actions' })
  const [busy, setBusy] = useState(false)

  const canMarkSent = !!doc?.uuid && kind !== 'expense' && doc.status !== 'cancelled' && doc.status !== 'refunded'
  const isSent = Boolean(doc?.sentAt)

  const toggleSent = async () => {
    if (!doc?.uuid || busy) return
    setBusy(true)
    try {
      if (isSent) {
        await API.delete(`/api/v2/sent-documents/${doc.uuid}`, { data: {} })
      } else {
        await API.post(`/api/v2/sent-documents/${doc.uuid}`, {})
      }
      toast.success(t(isSent ? 'markNotSentSuccess' : 'markSentSuccess'))
      onDone()
    } catch {
      toast.error(t('markSentError'))
    } finally {
      setBusy(false)
    }
  }

  return {
    canMarkSent,
    isSent,
    toggleSent,
    busy,
    label: t(isSent ? 'markNotSent' : 'markSent'),
  }
}
